module.exports = __webpack_public_path__ + "static/media/pickcell_connect.b0539a88.svg";